var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StackChart',{ref:"chart",attrs:{"unit":_vm.unit,"uuid":_vm.uuid,"scale":_vm.scale,"loading":_vm.loading,"title":_vm.widgettitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }